import styled from '@emotion/styled';
import { list } from 'src/assets/colors';
//@ts-expect-error
import RACING_PNG from './HorseRacing.png';
interface LinkItemType {
    imgSrc?: string
}

export const ImageContainer = styled('div', { label: 'ImageContainer' })<LinkItemType>`
    min-width: 112px;
    background-color: ${list.listItem.image.bgColor};
`;

export const ImageWrapper = styled('div', { label: 'ImageWrapper' })<LinkItemType>`
    width: 16px;
    height: 16px;
    margin: 45px auto auto auto;
    background-image: ${props => props.imgSrc !== undefined ? `url(${props.imgSrc})` : ''};
    background-size: cover;

`;
